export default __webpack_public_path__ + "static/media/yo.b4d86973.jpg";